import React, { useReducer, useRef, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';

const initialState = {
  adminMenuOpen: false,
  userMenuOpen: false,
  mobileMenuOpen: false,
};

function menuReducer(state, action) {
  switch (action.type) {
    case 'TOGGLE_ADMIN':
      return { ...initialState, adminMenuOpen: !state.adminMenuOpen };
    case 'TOGGLE_USER':
      return { ...initialState, userMenuOpen: !state.userMenuOpen };
    case 'TOGGLE_MOBILE':
      return { ...initialState, mobileMenuOpen: !state.mobileMenuOpen };
    case 'CLOSE_ALL':
      return initialState;
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

const Header = ({ onLoginClick, onSignUpClick, onBulkImportClick, onNewGroupClick, isAdmin, onLogoClick, onEditProfileClick, onChangePasswordClick }) => {
  const { user, setUser } = useUser();
  const [menuState, dispatch] = useReducer(menuReducer, initialState);
  const { adminMenuOpen, userMenuOpen, mobileMenuOpen } = menuState;

  const adminMenuRef = useRef(null);
  const userMenuRef = useRef(null);
  const navRef = useRef(null);

  const createMenuHandler = (handlerFn) => (e) => {
    e.preventDefault();
    dispatch({ type: 'CLOSE_ALL' });
    if (handlerFn) handlerFn();
  };

  const handleLogout = async (e) => {
    e.preventDefault();
    dispatch({ type: 'CLOSE_ALL' });
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    try {
      const response = await fetch('/api/v1/logout', {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
        },
      });

      if (response.ok) {
        setUser(null);
      } else {
        console.error('Logout failed');
      }
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        dispatch({ type: 'CLOSE_ALL' });
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  return (
    <header className="sticky-header">
      <nav ref={navRef}>
        <ul>
          <li>
            <a
              href="/"
              onClick={(e) => { if (onLogoClick) { e.preventDefault(); onLogoClick(); } }}
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <strong>Board Game Collection</strong>
            </a>
          </li>
        </ul>
      <div className="hamburger-menu" onClick={() => dispatch({ type: 'TOGGLE_MOBILE' })}>
        &#9776;
      </div>
      <div className={`nav-links ${mobileMenuOpen ? 'open' : ''}`}>
        <ul>
          {user ? (
              <>
              {isAdmin && (
                <li
                  ref={adminMenuRef}
                  className="dropdown-container"
                >
                  <a href="#" role="button" className="contrast" onClick={(e) => {
                    e.preventDefault();
                    dispatch({ type: 'TOGGLE_ADMIN' });
                  }}>Admin</a>
                  {adminMenuOpen && (
                    <ul className="dropdown-menu admin-dropdown" role="listbox">
                      <li><a href="/games/new" onClick={() => dispatch({ type: 'CLOSE_ALL' })}>New Game</a></li>
                      <li><a href="#" onClick={createMenuHandler(onBulkImportClick)}>Bulk Import</a></li>
                      <li><a href="#" onClick={createMenuHandler(onNewGroupClick)}>New Game Group</a></li>
                    </ul>
                  )}
                </li>
              )}
              <li
                ref={userMenuRef}
                className="dropdown-container"
              >
                <a
                  href="#"
                  role="button"
                  className="secondary user-menu-trigger"
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch({ type: 'TOGGLE_USER' });
                  }}
                >
                  <img src={user.photo} alt={`Avatar for ${user.name}`} className="avatar" />
                  &nbsp;
                  {user.name || user.email}
                </a>
                {userMenuOpen && (
                  <ul className="dropdown-menu user-dropdown" role="listbox">
                    <li><a href="#" onClick={createMenuHandler(onEditProfileClick)}>Edit Profile</a></li>
                    <li><a href="#" onClick={createMenuHandler(onChangePasswordClick)}>Change Password</a></li>
                    <li><a href="#" onClick={handleLogout}>Logout</a></li>
                  </ul>
                )}
              </li>
              </>
          ) : (
              <>
                <li><a href="#" role="button" onClick={createMenuHandler(onSignUpClick)} className="contrast">Sign Up</a></li>
                <li><a href="#" role="button" onClick={createMenuHandler(onLoginClick)}>Login</a></li>
              </>
          )}
        </ul>
      </div>
      </nav>
    </header>
  );
};

export default Header;
